import { AuthBottomBlock } from "modules/auth/layout/AuthBottomBlock";
import GoogleSSOButton from "modules/auth/authButtons/GoogleSSO";
import FacebookSSO from "modules/auth/authButtons/FacebookSSO";
import LinkedInSSO from "modules/auth/authButtons/LinkedInSSO";
import NavigateToSignIn, {
  INavigateToSignInProps,
} from "modules/auth/authNavigation/NavigateToSignIn";
import AuthNavigationContainer from "modules/auth/authNavigation/AuthNavigationContainer";
import { useI18n } from "i18n";
import { SOCIAL_AUTH_PROVIDERS } from "common";
import { Props } from "./SignUpForm";
import MicrosoftSSOButton from "../authButtons/MicrosoftSSO";
import MagicLinkSignIn from "../signIn/MagicLinkSignIn";
import EDCSSOButton from "../authButtons/EDCSSO";

type SignUpViewProps = Props &
  INavigateToSignInProps & {
    hideSignInCTA?: boolean;
  };

const SignUpView = ({ hideSignInCTA, ...props }: SignUpViewProps) => {
  const { t } = useI18n(["auth"]);

  return (
    <AuthBottomBlock>
      <EDCSSOButton
        text={t("auth:signup.with.provider", {
          provider: SOCIAL_AUTH_PROVIDERS.EDC,
        })}
      />
      <MicrosoftSSOButton
        text={t("auth:signup.with.provider", {
          provider: SOCIAL_AUTH_PROVIDERS.MICROSOFT,
        })}
      />
      <GoogleSSOButton
        {...props}
        text={t("auth:signup.with.provider", {
          provider: SOCIAL_AUTH_PROVIDERS.GOOGLE,
        })}
      />
      <LinkedInSSO
        text={t("auth:signup.with.provider", {
          provider: SOCIAL_AUTH_PROVIDERS.LINKEDIN,
        })}
      />
      <FacebookSSO
        {...props}
        text={t("auth:signup.with.provider", {
          provider: SOCIAL_AUTH_PROVIDERS.FACEBOOK,
        })}
      />
      <div className="email-container">
        <MagicLinkSignIn isSignUp />

        {!hideSignInCTA && (
          <AuthNavigationContainer>
            <NavigateToSignIn {...props} />
          </AuthNavigationContainer>
        )}
      </div>
    </AuthBottomBlock>
  );
};

export default SignUpView;
